import React from 'react'
// @ts-ignore
import { ReactComponent as DefaultIcon } from './default-icon.svg'
// @ts-ignore
import { ReactComponent as VideoIcon } from './video-icon.svg'
// @ts-ignore
import { ReactComponent as PdfIcon } from './pdf-icon.svg'

// @ts-ignore
import { ReactComponent as WhiteWebsite } from '../../assets/icons/White-Website.svg'
// @ts-ignore
import { ReactComponent as WhiteWord } from '../../assets/icons/White-Word.svg'
// @ts-ignore
import { ReactComponent as WhitePDF } from '../../assets/icons/White-PDF.svg'
// @ts-ignore
import { ReactComponent as WhiteText } from '../../assets/icons/White-Text.svg'
// @ts-ignore
import { ReactComponent as WhiteSlide } from '../../assets/icons/White-Slide.svg'
// @ts-ignore
import { ReactComponent as WhiteMedia } from '../../assets/icons/White-Media.svg'
// @ts-ignore
import { ReactComponent as WhiteSound } from '../../assets/icons/White-Sound.svg'
// @ts-ignore
import { ReactComponent as WhiteImage } from './White-Image.svg'
// @ts-ignore
import { ReactComponent as WhiteDefault } from './White-Default.svg'

import {
  mediaTypes,
  slideTypes,
  imageTypes,
  excelTypes,
  pdfTypes,
  wordTypes,
  soundTypes,
} from '@trivie/core/src/utils/fileUtils'

const videoExtensions = ['mp4', 'mov', 'avi', 'flv', 'mkv', 'wmv', 'avchd', 'webm', 'h264', 'mp4']

export const ResourceIcon = (props: any) => {
  const { extension, white } = props
  const massagedExtension = String(extension).toLocaleLowerCase().replaceAll('.', '')

  if (white) {
    if (mediaTypes.includes(massagedExtension)) return <WhiteMedia width={24} height={24} />
    else if (slideTypes.includes(massagedExtension)) return <WhiteSlide width={24} height={24} />
    else if (imageTypes.includes(massagedExtension)) return <WhiteImage width={24} height={24} />
    else if (excelTypes.includes(massagedExtension)) return <WhiteDefault width={24} height={24} />
    else if (pdfTypes.includes(massagedExtension)) return <WhitePDF width={24} height={24} />
    else if (wordTypes.includes(massagedExtension)) return <WhiteWord width={24} height={24} />
    else if (soundTypes.includes(massagedExtension)) return <WhiteSound width={24} height={24} />
    else if (massagedExtension === 'url') return <WhiteWebsite width={24} height={24} />
    else return <WhiteDefault width={24} height={24} />
  } else {
    if (videoExtensions.includes(massagedExtension)) {
      return <VideoIcon />
    } else if (massagedExtension === 'pdf') {
      return <PdfIcon />
    } else {
      return <DefaultIcon />
    }
  }
}
